var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoComments = function SvgNoComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#F8F9FA",
    rx: 40
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#noComments_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#808A93",
    d: "M35.757 20a15.757 15.757 0 0 0-13.126 24.471l-2.105 5.635a.856.856 0 0 0 .957 1.143l7.377-1.329A15.755 15.755 0 1 0 35.757 20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CED3D8",
    d: "M47.143 34.286a12.857 12.857 0 0 1 10.709 19.966l1.623 4.337a.857.857 0 0 1-.955 1.142l-5.748-1.03a12.857 12.857 0 1 1-5.629-24.415"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "noComments_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 20h40v40H20z"
  })))));
};
export default SvgNoComments;